export const CONNECTION_LOST = 'APP/CONNECTION/LOST';
export const CONNECTION_ESTABLISHED = 'APP/CONNECTION/ESTABLISHED';

export const SET_IS_MOBILE = 'APP/SET_IS_MOBILE';

export const OPEN_REFRESH_PAGE_MODAL = 'APP/MODALS/OPEN_REFRESH_PAGE_MODAL';
export const CLOSE_REFRESH_PAGE_MODAL = 'APP/MODALS/CLOSE_REFRESH_PAGE_MODAL';

export const OPEN_COOKIE_MODAL = 'APP/MODALS/COOKIE_MODAL/OPEN';
export const CLOSE_COOKIE_MODAL = 'APP/MODALS/COOKIE_MODAL/CLOSE';

export const OPEN_CHAT_MODAL = 'APP/MODALS/CHAT/OPEN';
export const CLOSE_CHAT_MODAL = 'APP/MODALS/CHAT/CLOSE';

export const SEND_MEDIA_METRICS = 'APP/MEDIAS/SEND_MEDIA_METRICS';
export const SEND_MEDIA_METRICS_SUCCESS = 'APP/MEDIAS/SEND_MEDIA_METRICS_SUCCESS';
export const SEND_MEDIA_METRICS_FAILURE = 'APP/MEDIAS/SEND_MEDIA_METRICS_FAILURE';
